// @flow

import * as React from 'react';
import { LoadingSpinner } from '@ta/styleguide.loading';
import styles from './VideoPlayerLoadingSkeleton.less';

const VideoPlayerLoadingSkeleton = () => (
  <div className={styles.container}>
    <LoadingSpinner inverted />
  </div>
);

export default VideoPlayerLoadingSkeleton;
